import CountriesStore from '../../../shared/features/countries/CountriesStore';
import PriceConfigStore from '../../../shared/features/priceConfig/PriceConfigStore';
import UserStore from '../../../shared/features/user/UserStore';
import UiStateStore from '../uiState/UiStateStore';
import CheckoutStore from '../checkout/CheckoutStore';
import SubscriptionPreviewStore from '../subscriptionPreview/SubscriptionPreviewStore';
import AreaUnitStore from '../../../shared/features/areaUnit/areaUnitStore';

class RootStore {
  userStore: UserStore<RootStore>;

  areaUnitStore: AreaUnitStore<RootStore>;

  uiStateStore: UiStateStore;

  checkoutStore: CheckoutStore;

  subscriptionPreviewStore: SubscriptionPreviewStore;

  priceConfigStore: PriceConfigStore<RootStore>;

  countriesStore: CountriesStore<RootStore>;

  constructor() {
    this.userStore = new UserStore(this);
    this.areaUnitStore = new AreaUnitStore(this);
    this.uiStateStore = new UiStateStore(this);
    this.checkoutStore = new CheckoutStore(this);
    this.subscriptionPreviewStore = new SubscriptionPreviewStore(this);
    this.priceConfigStore = new PriceConfigStore(this);
    this.countriesStore = new CountriesStore(this);
  }

  reset() {
    this.userStore.reset();
    this.areaUnitStore.reset();
    this.uiStateStore.reset();
    this.checkoutStore.reset();
    this.subscriptionPreviewStore.reset();
    this.priceConfigStore.reset();
    this.countriesStore.reset();
  }
}

const rootStore = new RootStore();

export type IRootStore = typeof rootStore;

export default rootStore;
